module.exports = __webpack_public_path__ + "static/media/placeholder_2.25c0a717.jpg";